import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './auth/authSlice';
import configReducer from './config/configSlice';
import dataReducer from './data/dataSlice';

const reducers = combineReducers({
  auth: authReducer,
  config: configReducer,
  data: dataReducer,
});

const persistConfig = {
  key: 'van-sale-pos-web-app-v1',
  storage,
  transforms: [],
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these actions for serializableCheck
        ignoredActions: ['persist/PERSIST', 'persist/PURGE'],
      },
    }),
});
export const persistor = persistStore(store);
// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
